import { Dialog, DialogPanel } from '@headlessui/react'
import { AnimatePresence, motion } from 'motion/react'
import { ReactNode } from 'react'

export interface SlideOverPanelProps {
	children?: ReactNode
	open: boolean
	onClose: () => void
}

export function SlideOverPanel({ children, open, onClose }: SlideOverPanelProps) {
	return (
		<AnimatePresence mode="popLayout">
			{open && (
				<Dialog static={true} open={open} onClose={onClose} className="relative z-50">
					{/* Backdrop */}
					<motion.div
						initial={{ opacity: 0 }}
						animate={{ opacity: 1 }}
						exit={{ opacity: 0 }}
						transition={{ duration: 0.2 }}
						className="fixed inset-0 bg-black/20 backdrop-blur-sm"
					/>

					{/* Panel container - centered with 10% border */}
					<div className="fixed inset-0 flex items-center justify-center">
						<DialogPanel
							as={motion.div}
							initial={{
								opacity: 0,
								scale: 0.95,
							}}
							animate={{
								opacity: 1,
								scale: 1,
								transition: {
									type: 'spring',
									duration: 0.5,
									bounce: 0.1,
								},
							}}
							exit={{
								opacity: 0,
								scale: 0.95,
								transition: {
									type: 'spring',
									duration: 0.4,
									bounce: 0,
								},
							}}
							className="w-[90vw] h-[90vh] bg-white shadow-2xl rounded-lg overflow-hidden"
						>
							{children}
						</DialogPanel>
					</div>
				</Dialog>
			)}
		</AnimatePresence>
	)
}
